import React from 'react';
import Icon from '../../../components/AppIcon';

const RecordingControls = ({ isRecording, onToggleRecording }) => {
  return (
    <div className="flex items-center gap-3">
      {isRecording ? (
        <div className="flex items-center gap-2 px-3 py-2 bg-red-600/20 border border-red-600 rounded-lg">
          <div className="w-3 h-3 bg-red-600 rounded-full animate-pulse" />
          <span className="text-red-400 text-sm font-medium">Recording</span>
          <button
            onClick={onToggleRecording}
            className="ml-2 p-1 hover:bg-red-600/30 rounded transition-colors"
            aria-label="Stop recording"
          >
            <Icon name="Square" size={16} color="#EF4444" />
          </button>
        </div>
      ) : (
        <button
          onClick={onToggleRecording}
          className="flex items-center gap-2 px-3 py-2 bg-[#374151] hover:bg-[#4B5563] text-gray-300 rounded-lg transition-colors"
          aria-label="Start recording"
        >
          <Icon name="Circle" size={16} />
          <span className="text-sm font-medium hidden md:block">Record</span>
        </button>
      )}

      {isRecording && (
        <div className="text-gray-400 text-xs hidden lg:block">
          Both participants have consented to recording
        </div>
      )}
    </div>
  );
};

export default RecordingControls;